<template>
  <div
    :data-alert-id="id"
    class="relative basis-full flex flex-row items-center text-[1rem] leading-8 head font-medium text-balance px-6 py-8 mb-6 border-2 text-[#213756] border-primary bg-primary/10 rounded-md"
  >
    <InformationCircleIcon class="w-[2.8em] h-[2.8em] mr-4 text-primary" />
    <p>
      You have confirmed your
      <strong>email address,</strong>
      your account is updated.
    </p>
    <button class="w-[1.8em] h-[1.8em] rounded-full cursor-pointer absolute right-3 top-3" @click.prevent="dismiss">
      <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30" class="w-full h-full">
        <g id="Group_797" data-name="Group 797" transform="translate(-1404 -6)" opacity="0.749">
          <circle
            id="Ellipse_57"
            data-name="Ellipse 57"
            cx="15"
            cy="15"
            r="15"
            transform="translate(1404 6)"
            fill="#d8d8d8"
          />
          <g id="i-remove" transform="translate(1413 15)">
            <g id="Group_262" data-name="Group 262">
              <line
                id="Line_74"
                data-name="Line 74"
                x1="12"
                y2="12"
                fill="none"
                stroke="#991e66"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
              />
              <line
                id="Line_75"
                data-name="Line 75"
                x1="12"
                y1="12"
                fill="none"
                stroke="#991e66"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
              />
            </g>
          </g>
        </g>
      </svg>
    </button>
  </div>
</template>

<script setup lang="ts">
import { InformationCircleIcon } from "@heroicons/vue/solid";

const id = "email-verification";

function dismiss() {
  const target = document.querySelector<HTMLDivElement>(`[data-alert-id="${id}"]`);
  if (!target) return;

  target.remove();
}
</script>
